import { Flex, Group } from '@mantine/core';
import type { Goal, Outcome } from '../../../api/strategy-client/strategy-client.type';
import type { Initiative } from '../../../api/initiative-client/initiative-client.type';
import { useTranslation } from 'react-i18next';
import { inkLight, secondaryBase } from '../../../styles/design-tokens';
import { Button } from '../../../ui-library/button/button';
import { Icon } from '../../../ui-library/icon/icon';
import { Tooltip } from '../../../ui-library/tooltip/tooltip';
import { H3 } from '../../../ui-library/typography/typography';

type EntityType = 'initiative' | 'outcome' | 'goal';

type Props = {
  entity: Initiative | Outcome | Goal | null;
  entityType: EntityType;
  openInfoModal: (isOpen: boolean) => void;
  openEditModal: (isOpen: boolean) => void;
};

export const StrategyPerformanceControlBar = ({ entity, entityType, openInfoModal, openEditModal }: Props) => {
  const i18n = useTranslation();
  if (!entity) {
    return null;
  }

  const isInternalEntity = entity.source === 'bloomfilter';

  return (
    <Group justify="space-between" align="center">
      <Flex gap={8} align="center">
        <Icon name="info" size={24} color={secondaryBase} pointer onClick={() => openInfoModal(true)} />
        <Tooltip
          variant="white"
          position="bottom"
          label={entity.name}
          disabled={!entity.name || (!!entity.name && entity.name.length <= 80)}
          maw={600}
          multiline
        >
          <H3
            style={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              cursor: 'default',
            }}
          >
            {entity.name && entity.name.length > 80 ? `${entity.name.substring(0, 80)}...` : entity.name || ''}
          </H3>
        </Tooltip>
      </Flex>
      {isInternalEntity && (
        <Button
          variant="outline"
          size="sm"
          radius="xl"
          leftSection={<Icon variant="filled" name="mode" size={16} color={inkLight} pointer />}
          onClick={() => openEditModal(true)}
        >
          {entityType === 'goal'
            ? `${i18n.t('common.actions.edit')} ${i18n.t('common.strategic_goal')}`
            : entityType === 'outcome'
              ? `${i18n.t('common.actions.edit')} ${i18n.t('common.outcome')}`
              : i18n.t('strategy.initiatives.edit_button')}
        </Button>
      )}
    </Group>
  );
};
